import { updatePromoSetting } from 'api/editor';
import mergeAndRemoveKey from 'editor/utils/mergeAndRemoveKey';
import { objFirstLevelJSONStringify, updateReduxObjKeyHandleDelete } from 'utils/objectManipulate';

export const UPDATE_SETTING_STYLE = 'UPDATE_SETTING_STYLE';
export const REPLACE_SETTING_STYLE = 'REPLACE_SETTING_STYLE';

const initState = {
    bgType: 1,
    bgColor: '',
    bgImgUrl: '',
    contentBgType: 1,
    contentBgColor: '',
    contentBgImgUrl: '',
    contentBorderRadius: 0,
    buttonBgColor: '',
    buttonTextColor: '',
    optionBgColor: '',
    optionTextColor: '',
    titleColor: '',
    descColor: ''
};

const reducer = (state = initState, action) => {
    switch (action.type) {
        case REPLACE_SETTING_STYLE:
            return action.payload;
        case UPDATE_SETTING_STYLE: {
            return updateReduxObjKeyHandleDelete(state, action.payload, action.updateAction);
        }
        default:
            return state;
    }
};

export default reducer;

export function updateSettingStyle(payload) {
    return {
        type: UPDATE_SETTING_STYLE,
        payload
    };
}

export function stringifyAndSaveAndUpdateSettingStyle(payload) {
    return async (dispatch, getState) => {
        const {
            settingStyle,
            promo: { id: promoId },
            sponsor: { id: sponsorId }
        } = getState();
        const stringifyData = objFirstLevelJSONStringify(payload);
        await updatePromoSetting(sponsorId, promoId, { Styles: stringifyData });
        dispatch({
            type: REPLACE_SETTING_STYLE,
            payload: mergeAndRemoveKey(settingStyle, payload)
        });
    };
}
